import ajaxUrl from "../api/ajaxUrl";
import appConfig from "../api/appConfig";
import $ from 'jquery';

class DataPoll {
  constructor() {
    this.name = 'DataPoll';
    this.pollInterval = appConfig.pollInterval;
    this.shouldPoll = false;
    this.ajaxUrl = ajaxUrl;
    this.keepPolling = true;
    this.pollInterval = appConfig.pollInterval;
    this.cachedData = null;
    this.timeOut = appConfig.ajaxTimeout;
  }

  getData() {
    const jqXHR = $.ajax(this.ajaxUrl, {
      method: "GET",
      data: {
        action: "vk_data",
      },
      cache: false,
      timeout: this.timeOut,
    });
    return jqXHR;
  }

  poll(doneCb, failCb, alwaysCb) {
    const _self = this;
    _self.getData()
      .done((data) => {
        _self.cachedData = data;
        doneCb(data);
      })
      .fail(failCb)
      .always((dataOrjqXHR, textStatus, jqXHROrerrorThrown) => {
        if (alwaysCb) {
          alwaysCb(dataOrjqXHR, textStatus, jqXHROrerrorThrown);
        }
        if (_self.keepPolling) {
          setTimeout(() => {
            _self.poll(doneCb, failCb, alwaysCb);
          }, _self.pollInterval);
        }
      });
  }

  start(doneCb, failCb, alwaysCb) {
    this.keepPolling = true;
    this.poll(doneCb, failCb, alwaysCb);
  }

  end() {
    this.keepPolling = false;
  }
}


export default DataPoll;